import { AccuracyTemplateInspectionGroup } from "@app/templates/accuracy/models";

export function filterDirectoryFacingInspectionGroup(inspectionGroups: AccuracyTemplateInspectionGroup[], hideDirectoryFacing: boolean): AccuracyTemplateInspectionGroup[] {
  if (hideDirectoryFacing) {
    const filteredInspectionGroups = inspectionGroups.map((group) => {
      if (group.name === 'Enrichment') {
        const filteredInspection = (group.inspections ?? []).filter((inspection) => inspection.name !== 'Directory Facing');
        return { ...group, inspections: filteredInspection }
      }
      return group;
    });
    return filteredInspectionGroups;
  }
  return inspectionGroups;
}
